import { __assign, __rest } from "tslib";
import React from "react";
import s from './button.module.css';
import propTypes from "prop-types";
export function ButtonIcon(_a) {
    var children = _a.children, className = _a.className, size = _a.size, type = _a.type, props = __rest(_a, ["children", "className", "size", "type"]);
    var classNames = [
        s['button-icon'],
        s["button-icon__".concat(size)],
        s["button-icon__".concat(type)],
        className || '',
    ];
    return (React.createElement("button", __assign({ className: classNames.join(' ') }, props), children));
}
ButtonIcon.propTypes = {
    children: propTypes.node,
    className: propTypes.string,
    size: propTypes.oneOf(['small', 'medium', 'large', 32, 40, 48]).isRequired,
    type: propTypes.oneOf(['primary', 'secondary', 'tetiary', 'plain', 'destructive', 'gray']).isRequired,
    onClick: propTypes.func,
    disabled: propTypes.bool,
    leadIcon: propTypes.node,
    tailIcon: propTypes.node,
};
//# sourceMappingURL=ButtonIcon.js.map